import { Delay } from "components/atoms/Delay";
import { fortuneTellerIcon } from "components/templates/無料占いBot";
import dayjs from "dayjs";
import { Balloon } from "features/無料占いBot/components/Balloon";
import { Confirmable } from "features/無料占いBot/components/Confirmable";
import { sum } from "lodash";
import { useFormContext } from "react-hook-form";
import { DateSelect } from "shared/components/molecules/DateSelect";
import { eventName, eventAction, useGaEvent } from "shared/hooks/useGaEvent";
import { FreeFortuneTheme } from "shared/models";
import { genres } from "./ThemeCards";
import { FreeFortuneThemeDetailSchema } from "@miror/types";

const fieldName = "birthday";

interface Props {
  themes: FreeFortuneTheme[] | FreeFortuneThemeDetailSchema[];
  theme: FreeFortuneTheme | FreeFortuneThemeDetailSchema;
}

export const SelectBirthday = ({ theme }: Props) => {
  const { register, watch } = useFormContext();
  const { sendEvent } = useGaEvent();

  const field = register(fieldName);
  const [value, answerId] = watch([fieldName, "answer"]);
  const date = dayjs(value).format("YYYY年MM月DD日");
  const genre = genres.find(
    (genre, idx1) =>
      theme.order <=
      sum(genres.map((genre, idx2) => (idx2 <= idx1 ? genre.chunk : 0)))
  );

  const onClickConfirm = () => {
    sendEvent({
      eventName: eventName.freeFortuneChatBot,
      eventAction: eventAction.freeFortuneChatBot.confirmMyBirthDay,
      eventParams: {
        theme_id: theme.id,
        answer_id: answerId,
      },
    });
  };

  return (
    <Confirmable
      name={fieldName}
      icon={fortuneTellerIcon}
      text={`生年月日は${date}でお間違いありませんか？`}
      onClickConfirm={onClickConfirm}
    >
      <Delay>
        <Balloon>
          {`ありがとうございます！鑑定のご依頼を確かに承りました🔮\n\nここまで頂いた回答を元に先生を選ばせて頂きました☺️\n\n今回無料体験鑑定を担当するのは\n\nMIROR所属 : 虹子先生です。\n\n虹子先生はMIRORでも特に「${genre.name}」の悩みに強く、鑑定が当たると評判で老若男女全ての方に愛される優しい先生です🙂\n\nまさにぴったりの先生だと思います！\n\nそれでは、ここからは虹子先生の鑑定体験をお楽しみください。`}
        </Balloon>
        <Delay icon={fortuneTellerIcon}>
          <Balloon icon={fortuneTellerIcon}>
            {`初めまして。\nこの度は鑑定の機会を頂きありがとうございます😌\n\n担当させて頂く虹子(こうこ)と申します。\n\n普段は数秘術、タロット、霊視を使って占っていますが、\n今回選んで頂いた内容については「霊視と数秘術」を中心に占って行きますね🔮\n\n霊視は主に相手のお気持ちや現状を見るのに使い、数秘術はそもそものお二人の相性などを見るのに使わせて頂きます。`}
          </Balloon>
          <Delay icon={fortuneTellerIcon}>
            <Balloon icon={fortuneTellerIcon}>
              {`それでは早速鑑定に取り掛かりたいと思うのですが、まず【生年月日】を伺ってもよろしいでしょうか？`}
            </Balloon>
            <div tw="justify-end mb-4 flex">
              <div tw="w-auto">
                <DateSelect {...field} />
              </div>
            </div>
          </Delay>
        </Delay>
      </Delay>
    </Confirmable>
  );
};
